import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, collection, query, where, limit, getDocs } from "firebase/firestore";
import { useEffect } from "react";
import { useAuthActions } from './../redux/reduxHook/useAuthActions';

export const useAuthInitializer = () => {
  const { login, logout, setCorrupted } = useAuthActions();
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
  

        // fetch Firestore doc once
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("authUID", "==", user.uid), limit(1));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docSnap = querySnapshot.docs[0];
          const userData = docSnap.data();

          // ✅ save plain data and path (not the DocumentReference)
          login({
            user: userData,
            userDocPath: docSnap.ref.path, // "users/abc123"
          });
          setCorrupted(false);
        } else {
          // Failsafe: User exists in Auth but has no Firestore profile.
          console.warn("User has Auth but no Firestore profile. Flagging account as corrupted.");
          setCorrupted(true);
        }
      } else {
      
        logout();
      }
    });

    return () => unsubscribe();
  }, [auth]);
};
